// Module-wrapped, so that we can call this to initialize pushy at any time
import $ from 'jquery'
import navChannel from '@/nav/channel'

/*! Pushy - v0.9.2 - 2014-9-13
 * Pushy is a responsive off-canvas navigation menu using CSS transforms & transitions.
 * https://github.com/christophery/pushy/
 * by Christopher Yee */
export default function (options) {
  $(function () {
    var pushy = options.menu, //menu jQuery object
      body = $('body'),
      push = $('.push'), //css class to add pushy capability
      siteOverlay = $('.site-overlay'), //site overlay
      pushyClass = 'pushy-left pushy-open', //menu position & menu open class
      pushyActiveClass = 'pushy-active', //css class to toggle site overlay
      pushClass = 'push-push', //css class to add pushy capability
      menuBtn = $(options.trigger), //css classes to toggle the menu
      menuSpeed = 200, //jQuery fallback menu speed
      menuWidth = pushy.width() + 'px' //jQuery fallback menu width

    function lockScrolling() {
      $('html, body').css('height', '100%')
    }

    function unlockScrolling() {
      $('html, body').css('height', 'auto')
    }

    var opened = false

    function togglePushy() {
      opened = !opened
      opened ? lockScrolling() : unlockScrolling()
      body.toggleClass(pushyActiveClass) //toggle site overlay
      pushy.toggleClass('pushy-left pushy-open')
      push.toggleClass(pushClass) //css class to add pushy capability
    }

    function openPushy() {
      opened = true
      lockScrolling()
      body.addClass(pushyActiveClass)
      pushy.removeClass('pushy-left')
      pushy.addClass('pushy-open')
      push.addClass(pushClass) //css class to add pushy capability
    }

    function openPushyFallback() {
      openPushy()
      pushy.animate({ left: menuWidth }, menuSpeed)
      push.animate({ left: menuWidth }, menuSpeed) //css class to add pushy capability
    }

    function closePushy() {
      opened = false
      unlockScrolling()
      body.removeClass(pushyActiveClass)
      pushy.addClass('pushy-left')
      pushy.addClass('pushy-leave')
      setTimeout(function () {
        pushy.removeClass('pushy-leave')
      }, menuSpeed)
      pushy.removeClass('pushy-open')
      push.removeClass(pushClass) //css class to add pushy capability
    }

    function closePushyFallback() {
      closePushy()
      pushy.animate({ left: '-' + menuWidth }, menuSpeed)
      push.animate({ left: '0px' }, menuSpeed) //css class to add pushy capability
    }

    //checks if 3d transforms are supported removing the modernizr dependency
    var cssTransforms3d = (function csstransforms3d() {
      var el = document.createElement('p'),
        supported = false,
        transforms = {
          webkitTransform: '-webkit-transform',
          OTransform: '-o-transform',
          msTransform: '-ms-transform',
          MozTransform: '-moz-transform',
          transform: 'transform'
        }

      // Add it to the body to get the computed style
      document.body.insertBefore(el, null)

      for (var t in transforms) {
        if (el.style[t] !== undefined) {
          el.style[t] = 'translate3d(1px,1px,1px)'
          supported = window
            .getComputedStyle(el)
            .getPropertyValue(transforms[t])
        }
      }

      document.body.removeChild(el)

      return (
        supported !== undefined && supported.length > 0 && supported !== 'none'
      )
    })()

    if (cssTransforms3d) {
      //toggle menu
      menuBtn.click(function () {
        togglePushy()
      })
      //close menu when clicking site overlay
      siteOverlay.click(function () {
        closePushy()
      })
      navChannel.on('sideNav:close', function () {
        closePushy()
      })
    } else {
      //jQuery fallback
      pushy.css({ left: '-' + menuWidth }) //hide menu by default

      //toggle menu
      menuBtn.click(function () {
        if (opened) {
          closePushyFallback()
        } else {
          openPushyFallback()
        }
      })

      //close menu when clicking site overlay
      siteOverlay.click(function () {
        closePushyFallback()
      })
      navChannel.on('sideNav:close', function () {
        closePushyFallback()
      })
    }
  })
}
